"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateGamificationActivity = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
/* istanbul ignore file @preserve -- api */

/**
 * A hook that creates a function for creating a gamification activity.
 * The function dispatches an API call to create the activity only for a logged-in user and specified activity type.
 * Requires being wrapped with TokenProvider, EnvironmentProvider, and GlobalApi ApiClientProvider.
 */
const useCreateGamificationActivity = ({
  activityType
} = {}) => {
  const {
    isAnonymousUser,
    isUserVerified,
    customerId
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const createGamificationActivity = (0, _react.useCallback)(async () => {
    if (!isAnonymousUser && isUserVerified && activityType) {
      await (0, _globalApiClientReact.createCustomerActivity)(globalApiClient, customerId, {
        activityType
      }, {
        [_fetching.TENANT_CONTEXT]: tenant
      });
    }
  }, [activityType, customerId, globalApiClient, isAnonymousUser, isUserVerified, tenant]);
  return {
    createGamificationActivity
  };
};
exports.useCreateGamificationActivity = useCreateGamificationActivity;
//# sourceMappingURL=useCreateGamificationActivity.js.map